<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <!-- Close button -->
      <button class="modal-close-button" @click="$emit('close')">✕</button>

      <!-- Equipment list -->
      <ul class="equipment-list">
        <li v-for="(eq, idx) in equipmentList" :key="idx">
          <button
            type="button"
            class="equipment-item-button"
            @click="selectEquipment(eq)"
          >
            {{ eq.location }}
          </button>
        </li>
      </ul>

      <!-- Brand / Model / Serial fields -->
      <div v-if="selectedExistingEquipment" class="additional-fields">
        <div class="form-group">
          <label for="brand">Brand</label>
          <input
            id="brand"
            v-model="selectedExistingEquipment.brand"
            type="text"
            placeholder="Enter brand"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="model">Model Number</label>
          <input
            id="model"
            v-model="selectedExistingEquipment.model"
            type="text"
            placeholder="Enter model number"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="serial">Serial Number</label>
          <input
            id="serial"
            v-model="selectedExistingEquipment.serial"
            type="text"
            placeholder="Enter serial number"
            class="form-control"
          />
        </div>
      </div>

      <!-- Confirm button -->
      <div class="modal-footer">
        <button
          :disabled="!selectedExistingEquipment"
          @click="$emit('select', selectedExistingEquipment)"
          class="btn btn-primary"
        >
          Select & Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectEquipmentModal",
  props: {
    equipmentList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedExistingEquipment: null
    };
  },
  methods: {
    selectEquipment(eq) {
      this.selectedExistingEquipment = eq;
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  overflow-y: auto;
}

.modal-container {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  max-width: 500px;
  width: 100%;
  position: relative;
}

.modal-close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
}

.equipment-list {
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
}

.equipment-list li + li {
  margin-top: 0.5rem;
}

.equipment-item-button {
  width: 100%;
  text-align: left;
  background-color: #f5f5f5;
  border: none;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
}

.equipment-item-button:hover {
  background-color: #e0e0e0;
}

.form-group {
  margin-bottom: 1rem;
}

.additional-fields .form-group {
  margin-top: 0.5rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}
</style>
